<template>
  <v-card v-if="editMerchantProfile">
    <v-toolbar dark color="white">
      <v-btn icon dark color="black" @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>
        <span style="color: black;" class="ml-8">Owner Profile</span>
      </v-toolbar-title>
    </v-toolbar>
    <div class="px-4 fs-12 pt-4">
      <v-row>
        <v-col style="text-align:center;justify-content:center;">
          <div
            v-bind:style="{
              'border-radius': '4px',
              position: 'relative',
              display: 'inline-block',
              'box-sizing': 'border-box',
            }"
          >
            <input
              type="file"
              name="file"
              @change="filesChange($event.target.name, $event.target.files)"
              accept="image/*"
              v-bind:style="{
                width: '4.375rem',
                height: '4.375rem',
                'border-radius': '10px',
                'background-color': '#eee',
                'background-repeat': 'no-repeat !important',
                'background-size': 'contain !important',
                'background-position': 'center !important',
                'background-image':
                  ownerDetails.profilePhoto == '' ||
                  ownerDetails.profilePhoto == null
                    ? ''
                    : 'url(\'' + ownerDetails.profilePhoto + '\') !important',
                overflow: 'hidden',
                'padding-left': '4.375rem',
                'box-shadow': '0px 0px 5px 5px rgba(0,0,0,0.48)',
              }"
            />
          </div>
          <v-icon style="top:20px;left:-57px;">mdi-camera</v-icon>
        </v-col>
      </v-row>
      <div style="display: grid;grid-template-columns: 60px auto">
        <span class="pt-2 warm-grey compact">
          Name
          <span class="mandatory">*</span>
        </span>
        <span style="height: 1rem;">
          <v-text-field
            v-model="ownerDetails.ownerName"
            dense
            class="compact"
            required
          >{{ ownerDetails.ownerName }}</v-text-field>
        </span>
      </div>
      <div style="display: grid;grid-template-columns:  60px auto">
        <span class="pt-2 warm-grey compact">Email</span>
        <span style="height: 1rem;">
          <v-text-field
            v-model="ownerDetails.ownerEmailId"
            type="email"
            dense
            class="compact"
          >{{ ownerDetails.ownerEmailId }}</v-text-field>
        </span>
      </div>
      <div style="display: grid;grid-template-columns: 60px auto">
        <span class="pt-2 warm-grey compact">
          Mobile
          <span class="mandatory">*</span>
        </span>
        <span style="height: 1rem;">
          <v-text-field
            type="tel"
            :maxlength="10"
            dense
            v-model="ownerDetails.ownerNumber"
            class="compact"
            :rules="[
                  () => !!ownerDetails.ownerNumber || 'This field is required',
                  () =>
                    (!!ownerDetails.ownerNumber && ownerDetails.ownerNumber.length == 10) ||
                    'Mobile must be 10 characters',
                ]"
            counter="10"
            requrired
          >{{ ownerDetails.ownerNumber }}</v-text-field>
        </span>
      </div>
      <v-row style="width:100%;position: absolute; bottom:0px;">
        <v-col style="justify-content:center;text-align:center;">
          <v-btn color="gray" text large @click="close()" class="px-12">CANCEL</v-btn>
        </v-col>
        <v-col style="justify-content:center;text-align:center;">
          <v-btn
            id="submit"
            :disabled="!ownerDetails.ownerName || !ownerDetails.ownerNumber"
            color="primary"
            depressed
            large
            class="px-12"
            @click="save()"
          >SAVE</v-btn>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import axios from "./../../plugins/axios";
import helper from "./../../utils/helper";
import WIOM_APIS from '../../utils/wiom-apis';
export default {
  name: "EditMerchantProfile",
  props: [
    "ownerDetails",
    "selectedLocation",
    "userData",
    "editMerchantProfile"
  ],
  data: function() {
    return {
      ownerName: "",
      ownerNumber: "",
      ownerEmailId: "",
      profilePhoto: ""
    };
  },
  methods: {
    filesChange: function(fieldName, fileList) {
      //console.log(fieldName, fileList);
      if (!fileList.length) return;
      const headerPhoto = new FormData();
      // dict of all elements
      headerPhoto.append("file", fileList[0]);
      headerPhoto.append("nameAppender", this.settingId);
      WIOM_APIS.uploadFile(headerPhoto).then(response => {
        this.ownerDetails.profilePhoto = response;
      });
    },
    close: function() {
      this.$emit("close");
    },
    save: function() {
      //console.log("save clicked");
      if (this.ownerDetails.ownerName && this.ownerDetails.ownerName != "") {
        if (
          this.ownerDetails.ownerNumber &&
          this.ownerDetails.ownerNumber != ""
        ) {
          axios
            .post(
              "/wiom/updateUserProfile?userId=" +
                this.userData.userid +
                "&i2e1-admin-token=" +
                helper.getCookie("token") +
                "&i2e1-admin-view-token=" +
                helper.getCookie("token"),
              {
                name: this.ownerDetails.ownerName,
                email: this.ownerDetails.ownerEmailId,
                mobile: this.ownerDetails.ownerNumber,
                username: this.ownerDetails.ownerUsername,
                profilePhoto: this.ownerDetails.profilePhoto
              }
            )
            .then(() => {
              this.$emit("save");
            });
        }
      }
    }
  },
  watch: {
    ownerDetails: function() {
      this.profilePhoto = this.ownerDetails.profilePhoto;
      this.ownerName = this.ownerDetails.ownerName;
      this.ownerNumber = this.ownerDetails.ownerNumber;
      this.ownerEmailId = this.ownerDetails.ownerEmailId;
    }
  }
};
</script>
